<div class="questionnaire-field-spacer d-flex flex-column">
    <textarea class="text-area" pTextarea id="over_label" [formControl]="formControl" [rows]="props.rows" [cols]="props.cols"></textarea>
    <formly-validation-message [field]="field" *ngIf="formControl?.invalid &&
  formControl?.dirty" />
</div>
